<button 
  class="tab-button"
  [ngStyle]="tabStyles | theme"
  (mousedown)="onClick($event)"
  (touchstart)="onClick($event)"
>
  {{ label }}
</button>

